/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shape, string, object } from 'prop-types';
import {
    Button, withStyles,
} from '@material-ui/core';
import { updateOrder } from '../../../../../../../../state/ducks/Cart/ducks/UpdateCart/UpdateCart-Actions';
import { useDebounce } from '../../../../../../../helpers/page/pageHelpers';
import { getFeatureFlag } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import SiteLoader from '../../../../../../../pages/Checkout/containers/Common/SiteLoader/SiteLoader';

const styles = (theme) => ({
    quantityContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '36px',
        marginRight: '16px',
        position: 'relative',
    },
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '128px',
        minWidth: '83px',
        border: '1px solid #C4C4C4',
        borderRadius: '3px',
    },
    addIcon: {
        padding: '0px',
        backgroundColor: 'transparent',
        fontSize: '24px',
        border: 'unset',
        display: 'flex',
        cursor: 'pointer',
        width: '12px',
        height: '12px',
        outlineColor: 'transparent',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '40px',

    },
    inputField: {
        maxWidth: '33%',
        height: '36px',
        padding: '4px 0px',
        textAlign: 'center',
        borderTop: 'unset',
        border: 'unset',
        outline: '1px solid #C4C4C4',
        fontSize: '16px',
        lineHeight: '20px',
        fontFamily: 'Area Variable',
    },
    removeIcon: {
        padding: '0px',
        backgroundColor: 'transparent',
        fontSize: '24px',
        border: 'unset',
        display: 'flex',
        cursor: 'pointer',
        width: '12px',
        height: '12px',
        outlineColor: 'transparent',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '40px',
        '& svg': {
            fill: '#000000',
        },
    },
    disabledButton: {
        '& svg': {
            fill: '#D9D9D9',
            cursor: 'default',
        },
    },
    errorMessage: {
        color: theme.palette.cms?.errorMessage || '#DF3030',
        fontSize: '12px',
        lineHeight: '16px',
        position: 'absolute',
        bottom: '-20px',
        '@media only screen and (max-width: 600px) ': {
            fontSize: '11px',
            bottom: '-17px',
        },
    },
    loaderContainer: {
        position: 'absolute',
        left: '28%',
    },
});

const ItemStepperQuantity = ({
    orderItem, classes,
}) => {
    const dispatchAction = useDispatch();
    const [valueQty, setValueQty] = useState(Number(orderItem.itemInfo.quantity) || 1);
    const [isLoading, setIsLoading] = useState(false);
    const isStepperQuantityEnabled = useSelector(getFeatureFlag('is-quantity-stepper-precheckout-enabled'));
    const maxQty = (['1030', '1033'].includes(orderItem.product.productCode) && !orderItem.personalization?.personalizationLines?.[0]) || orderItem.personalization?.personalizationType === 'EXTERNAL' ? 10 : 99;
    const [errorMessage, setErrorMessage] = useState(false);

    const isTryMeProduct = orderItem.product?.tryMe === 'true';

    const isSpecialProduct = ['NBCU', 'DDELVR', 'GREETINGCARD-ITEM', 'CLUB', 'COLLECTION'].includes(orderItem.itemInfo?.lineItemType);

    const componentProducts = orderItem.components?.length > 0
        ? orderItem.components.filter((item) => ['CYO', 'PYO', 'PMLADDON', 'COLLECTION'].includes(item.itemInfo.lineItemType))
        : [];

    const updateOrderQuantity = (newValueQty) => {
        const reqObj = {
            quantity: newValueQty,
            orderItemId: orderItem.cartItemId,
            callback: setIsLoading,
        };
        const updateOrderProps = {
            updateType: 'quantity',
        };

        dispatchAction(updateOrder(reqObj, updateOrderProps));
    };

    const lazyUpdateOrderQuantity = useDebounce(updateOrderQuantity, 500); // 500ms debounce delay

    const handleChange = (event, type = 'change', submit = false) => {
        let newValueQty = parseInt(event.target.value, 10);

        if (type === 'increment') {
            if (Number(valueQty) === 99) {
                newValueQty = Math.min(valueQty, maxQty);
                setErrorMessage(true);
                setValueQty(valueQty);
            } else {
                newValueQty = Math.min(valueQty + 1, maxQty); // Prevent values greater than maxQty
                setValueQty(newValueQty);
                setErrorMessage(false);
            }
        } else if (type === 'decrement') {
            newValueQty = Math.max(valueQty - 1, 1); // Prevent negative values
            setValueQty(newValueQty);
            setErrorMessage(false);
        } else if (type === 'change') {
            const rangeRegex = (/^[1-9][0-9]?$|^99$/);
            if (event.target.value === '') {
                setValueQty('');
                setErrorMessage(false);
            } else if (rangeRegex.test(event.target.value)) {
                setValueQty(Number(event.target.value));
                if (Number(event.target.value) < 99) {
                    setErrorMessage(false);
                }
            }
        }
        if (submit) {
            const changeValue = newValueQty === '0' || newValueQty === '' || !newValueQty ? '1' : newValueQty;
            setIsLoading(true);
            setValueQty(changeValue);
            lazyUpdateOrderQuantity(changeValue);
        }
    };

    if (isStepperQuantityEnabled
        && orderItem?.product?.brandCode !== '1036'
        && !isSpecialProduct
        && !isTryMeProduct
        && componentProducts.length === 0
        && !['PASSPORT', 'DONATION'].includes(orderItem?.itemInfo?.lineItemType)
    ) {
        return (
            <div className={classes.quantityContainer}>
                <div
                    className={classes.mainContainer}
                >
                    <Button className={Number(valueQty) === 1 ? `${classes.disabledButton} ${classes.removeIcon}` : classes.removeIcon} onMouseDown={(event) => handleChange(event, 'decrement', true)}   disabled={Number(valueQty) === 1}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                            <rect x="12" y="5.33337" width="1.33333" height="11" rx="0.5" transform="rotate(90 12 5.33337)"  />
                        </svg>
                    </Button>
                    <input
                        name="quantity"
                        label="quantity"
                        title="quantity"
                        value={valueQty}
                        onChange={(event) => handleChange(event, 'change', false)}
                        onBlur={(event) => handleChange(event, 'change', true)}
                        type="text"
                        inputProps={{
                            className: classes.inputQty,
                        }}
                        className={classes.inputField}
                    />
                    <Button className={classes.addIcon} onMouseDown={(event) => handleChange(event, 'increment', true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                            <rect x="6.00024" y="0.5" width="1" height="11" rx="0.5" fill="#000000" stroke="#000000" />
                            <rect x="12" y="5.64282" width="1" height="11" rx="0.5" transform="rotate(90 12 5.64282)" fill="#000000" stroke="#000000" />
                        </svg>
                    </Button>
                </div>
                <div className={classes.loaderContainer}>
                    {isLoading && <SiteLoader />}
                </div>
                {errorMessage && <span className={classes.errorMessage}>Maximum quantity 99 allowed</span>}

            </div>
        );
    }
    return <span className={classes.qtyLabel}>Qty: <span>{orderItem.itemInfo?.quantity}</span></span>;
};

ItemStepperQuantity.propTypes = {
    orderItem: shape({
        xOrderAttrValues: shape({
            tryMe: string,
        }),
    }),
    classes: object.isRequired,
};

ItemStepperQuantity.defaultProps = {
    orderItem: {
        cartItemId: '',
        xOrderAttrValues: {
            tryMe: '',
        },
    },
};

export default withStyles(styles)(ItemStepperQuantity);
